import React, { Component, useState, useContext } from "react";
import ReactDOM from "react-dom";

import PAContentBlock from "../PAContentBlock";
import { Link } from "react-router-dom";
import PAInputPrices from "../PAInputPrices";
import PAwebhooks from "../PAwebhooks";
import DatePickerExample from "../DatePicker";
import SelectExample from "../SelectExample";
import SwitchExample from "../SwitchExample";
import PAInputUpgrades from "../PAInputUpgrades";
import PACollapse from "../PACollapse";
import PACollapsePrices from "../PACollapsePrices";
import PAgameKeysDistr from "./PAgameKeysDistr";
import PAgameKeys, { PAgameKeysStep1, PAgameKeysStep2, PAgameKeysStep3 } from "./PAgameKeys";




import { IntlProvider } from "react-intl";

import {
    InputCopy,
    FormGroup,
    Select,
    Tooltip,
    StatusDot,
    Checkbox,
    Subheader,
    Head,
    Button,
    Card,
    Input,
    RadioGroup,
    Icon,
    ButtonAction,
    Tag,
    Notification,
    StepTabs,
    FormFooter
} from 'xsolla-uikit';

import { setTimeout } from "core-js";

import { ContextConsumer, GlobalContext } from '../PA';



export default function PAgameKeysWizard({
    wizard,
    handleModal,
    sku = null
  }) {

  const [state = { wizard }, setState] = useState();

  const steps = [
    { label: "Type of purchase" },
    { label: "Pricing" },
    { label: "Delivery" }
  ].map((step, index) => ({
    // {label: 'Test Results', disabled: true},
    ...step
    // onClick: this.handleStepClick(index + 1)
  }));

  const handleWizard = newState => {
    newState = newState || state.wizard;
    // if (newState > 4) newState = 1;
    setState({
      wizard: newState
    });
  };

  return (
    <React.Fragment>
      {state.wizard === 4 && (
        <div
          style={{
            position: "absolute",
            top: 256,
            left: 0,
            right: 0,
            bottom: 94,
            background: "#F7FAFF",
            zIndex: 0
          }}
        />
      )}

      <div style={{ position: "relative", zIndex: 1 }}>
        {/* {state.wizard !== 4 && <FormGroup indentation="lg"><Head>New virtual asset</Head></FormGroup>} */}

        {state.wizard === 4 && (
          <FormGroup>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%"
              }}
            >
              <div
                style={{ marginTop: 20 }}
                className="launcher-published-dlg__status-title-img-background"
              >
                <img
                  src="//cdn.xsolla.net/publisher-v4/checkmark-white.32731f.svg"
                  alt
                />
              </div>

              <Head>Virtual Asset Created!</Head>
            </div>
          </FormGroup>
        )}

        {/* {state.wizard !== 4 && (
          <FormGroup indentation="lg">
            <StepTabs current={state.wizard} steps={steps} />
          </FormGroup>
        )} */}

        {/* {this.props.children} */}

        <PAgameKeysStep1/>


        <FormFooter>
          <Button appearance="secondary" disabled={true}>Save asset</Button>
        </FormFooter>

      </div>
    </React.Fragment>
  );
}
